var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53556 11.1526C8.54631 11.9339 7.30326 12.3992 5.95325 12.3992C2.72685 12.3992 0.111328 9.74172 0.111328 6.46353C0.111328 3.18533 2.72685 0.527832 5.95325 0.527832C9.17966 0.527832 11.7952 3.18533 11.7952 6.46353C11.7952 7.8352 11.3373 9.0982 10.5683 10.1033L14.5023 14.1005C14.7874 14.3902 14.7874 14.86 14.5023 15.1498C14.2171 15.4395 13.7547 15.4395 13.4695 15.1498L9.53556 11.1526ZM10.3347 6.46353C10.3347 8.92217 8.37306 10.9153 5.95325 10.9153C3.53345 10.9153 1.57181 8.92217 1.57181 6.46353C1.57181 4.00488 3.53345 2.01176 5.95325 2.01176C8.37306 2.01176 10.3347 4.00488 10.3347 6.46353Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.b2297a282e14714e481914472e27a347.svg";
export { ForwardRef as ReactComponent };